import React from 'react';
import { ColorPicker } from '../ui/color-picker.component';
import { getUserColor } from '../../lib/utils/color-utils';

interface TechnicianColorPickerProps {
  userId: string;
  currentColor?: string;
  onColorSelect: (color: string | null) => void;
  disabled?: boolean;
}

export const TechnicianColorPicker: React.FC<TechnicianColorPickerProps> = ({ 
  userId, 
  currentColor, 
  onColorSelect, 
  disabled = false 
}) => {
  const autoGeneratedColor = getUserColor(userId);

  return (
    <ColorPicker
      currentColor={currentColor}
      onColorSelect={onColorSelect}
      disabled={disabled}
      defaultColor={autoGeneratedColor}
      showReset={true}
      label="Farbe für Techniker wählen"
      placeholder={currentColor || autoGeneratedColor}
    />
  );
};